import React, { Component } from "react";
import ROUTES from "../../constants/routes";
import { NavLink, withRouter } from "react-router-dom";

import "./NavigationTabs.sass";
import { MoreTabsButton } from "./MoreTabsButton";

class NavigationTabs extends Component {
  hiddenScrollContainer = React.createRef();

  state = {
    isAddEvent: this.props.match.path === ROUTES.NEW_ADD_EVENT,
    totalAllowedLinks: 3,
    links: [
      {
        title: 'Info',
        route: this.isAddEvent ?
          ROUTES.NEW_ADD_EVENT :
          ROUTES.NEW_EVENT_INFO,
      },
      {
        title: 'PDF',
        route: ROUTES.NEW_EVENT_PDF,
      },
      {
        title: 'Tickets',
        route: ROUTES.NEW_EVENT_TICKETS,
      },
      {
        title: 'Email',
        route: ROUTES.NEW_EVENT_EMAIL,
      },
      {
        title: 'Wallets',
        route: ROUTES.NEW_EVENT_WALLETS,
      },
      {
        title: 'Payments',
        route: ROUTES.NEW_EVENT_PAYMENT_METHODS,
      },
      {
        title: 'Themes',
        route: ROUTES.NEW_EVENT_THEMES,
      },
      {
        title: 'Transactions',
        route: ROUTES.NEW_EVENT_TRANSACTIONS,
      },
      {
        title: 'Guestlist',
        route: ROUTES.NEW_EVENT_GUESTLIST,
      },
      {
        title: 'Sell',
        route: ROUTES.NEW_EVENT_SELL.split("/").slice(0, -1).join("/"),
      },
      {
        title: 'Seats',
        route: ROUTES.NEW_EVENT_SEATS,
      },
      {
        title: 'Reports',
        route: ROUTES.NEW_EVENT_REPORTS,
      },
      {
        title: 'Statistics',
        route: ROUTES.NEW_EVENT_STATISTICS,
      },
      {
        title: 'Management',
        route: ROUTES.NEW_EVENT_MANAGEMENT,
      },
    ],
  };

  goToPage = (route) => {
    return route.replace(":id", this.props.match.params.id);
  };

  isPageActive = (match, location, title) => {
    const isTicket = location.pathname.includes('/ticket/');
    const isSell = location.pathname.includes('/sell/');

    const isActive = match ||
      (isTicket && title === "Tickets") ||
      (isSell && title === "Sell") ||
      (this.state.isAddEvent && title === "Info");

    return isActive;
  };

  static getDerivedStateFromProps(props) {
    if (props.match.params.id) {
      return {
        isAddEvent: false,
      };
    }
    return null;
  }

  handleMenuItemClick(link) {
    const { links, totalAllowedLinks } = this.state;
    const route = this.goToPage(link.route);
    this.props.history.push({pathname: route});

    const linkIdx = links.findIndex(currLink => link.route === currLink.route);
    const newHiddenLink = {...links[totalAllowedLinks - 1]}

    links[totalAllowedLinks - 1] = links[linkIdx];
    links[linkIdx] = newHiddenLink;
    this.setState({links});
  }

  componentDidMount() {
    let totalAllowedLinks = 0

    if (this.hiddenScrollContainer.current) {
      const container = this.hiddenScrollContainer.current;
      const windowWidth = window.screen.width - 60 - 85;
      const containerWidth = container.scrollWidth;
      const tabs = container.children;

      if (windowWidth >= containerWidth) {
        this.setState({totalAllowedLinks: 99});

        return;
      }

      let totalAllowedWidth = 0;

      for (let tab of tabs) {
        if (totalAllowedWidth + tab.scrollWidth <= windowWidth) {
          totalAllowedWidth = totalAllowedWidth + tab.scrollWidth;
          totalAllowedLinks++;
        } else {
          break;
        }
      }
    }

    const { links } = this.state;
    let targetRoute = this.props.match.path;

    if (ROUTES.NEW_EVENT_SELL === targetRoute) {
      targetRoute = targetRoute.split("/").slice(0, -1).join("/")
    }

    const targetLinkIdx = links.findIndex(currLink => targetRoute === currLink.route);

    if (targetLinkIdx >= totalAllowedLinks) {
      const newHiddenLink = {...links[totalAllowedLinks - 1]}

      links[totalAllowedLinks - 1] = links[targetLinkIdx];
      links[targetLinkIdx] = newHiddenLink;
    }

    this.setState({
      totalAllowedLinks,
      links,
    })
  }

  render() {
    const { links, totalAllowedLinks } = this.state;

    const menuItems = links.slice(totalAllowedLinks).map(link => ({
      text: link.title,
      onClick: (link) => this.handleMenuItemClick(link),
      data: link,
      className: 'nav-tabs__action-item'
    }))

    return (
      <nav className="nav-tabs">
        <div className="nav-tabs__container nav-tabs__container--hidden" ref={this.hiddenScrollContainer}>
          <div
            className="nav-tabs__item"
            to={this.goToPage(links[0].route)}
            key={links[0].route}
          >
            <span>{links[0].title}</span>
          </div>
          {links.slice(1).map(link => {
            if (!this.state.isAddEvent) {
              return (
                <div
                  className="nav-tabs__item"
                  key={link.route}
                >
                  <span>{link.title}</span>
                </div>
              )
            } else {
              return (
                <div
                  className="nav-tabs__item disabled"
                  key={link.route}
                >
                  <span>{link.title}</span>
                </div>
              )
            }
          })}
        </div>
        <div className="nav-tabs__container">
          <NavLink
            className="nav-tabs__item"
            to={this.goToPage(links[0].route)}
            key={links[0].route}
            isActive={(match, location) =>
              this.isPageActive(match, location, links[0].title)
            }
          >
            <span>{links[0].title}</span>
          </NavLink>
          {links.slice(1, totalAllowedLinks).map(link => {
            if (!this.state.isAddEvent) {
              return (
                <NavLink
                  className="nav-tabs__item"
                  to={this.goToPage(link.route)}
                  key={link.route}
                  isActive={(match, location) =>
                    this.isPageActive(match, location, link.title)
                  }
                >
                  <span>{link.title}</span>
                </NavLink>
              )
            } else {
              return (
                <div
                  className="nav-tabs__item disabled"
                  key={link.route}
                >
                  <span>{link.title}</span>
                </div>
              )
            }
          })}

          {totalAllowedLinks < links.length && (
            <MoreTabsButton menuItems={menuItems} disabled={this.state.isAddEvent} />
          )}
        </div>
      </nav>
    ); 
  }
};

export default withRouter(NavigationTabs);

